/*
 * Made Fur Glam: questionario Brevo in popup.
 * Nessuna dipendenza. L'invio resta quello originale di Brevo (main.js di sibforms.com):
 * questo file mostra/nasconde i gruppi dei cani, gestisce il popup e mostra il ringraziamento
 * solo quando Brevo conferma l'invio accettato.
 */
(function () {
  'use strict';
  if (window.MFGQuestionario) return; // file incluso due volte: una sola inizializzazione

  var LOG = '[Made Fur Glam]';
  var STORE = { seen: 'mfg-q-seen' };
  var instances = {};

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function setAttr(el, name, value) {
    if (value === null) el.removeAttribute(name);
    else el.setAttribute(name, value);
  }

  function session(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
  }

  /* ---------------------------------------------------------------------------
   * 1. Domande sui cani in base a "Quanti cani hai?"
   * Stessa logica del file definitivo made-fur-glam-questionario-5-cani.html.
   * ------------------------------------------------------------------------- */

  // Valori letti dall'HTML Brevo di questo modulo.
  // NUM_CANI_TOTALE: "Uno e viziatissimo" = 1 ... "Cinque, più siamo, meglio è" = 5
  var DOGS_BY_VALUE = { '1': 1, '2': 2, '3': 3, '4': 4, '5': 5 };
  // RAZZA_CANE, RAZZA_CANE_2 ... RAZZA_CANE_5: opzione "Altra razza"
  var OTHER_BREED_VALUE = '25';

  function initDogs(form) {
    if (!form || form.hasAttribute('data-mfg-cani')) return null;

    // Blocco Brevo "padding: 8px 0" che contiene domanda, campo, errore e testo di aiuto.
    function blockOf(el) {
      return el && el.closest('#sib-form > div');
    }

    function labelOf(field) {
      return form.querySelector('label[for="' + field.id + '"]');
    }

    var dogs = [];
    for (var n = 1; n <= 5; n++) {
      var suffix = n === 1 ? '' : '_' + n;
      var breed = form.querySelector('#RAZZA_CANE' + suffix);
      var other = form.querySelector('#ALTRA_RAZZA' + suffix);
      var birth = form.querySelector('#NASCITA_CANE' + suffix);
      var title = blockOf(breed) && blockOf(breed).previousElementSibling;
      // Se la struttura non è quella attesa, il modulo resta com'era.
      if (!blockOf(breed) || !blockOf(other) || !blockOf(birth) || !labelOf(breed) || !labelOf(birth) ||
          !breed.closest('.sib-select') || !title || !title.querySelector('.sib-text-form-block') ||
          title.querySelector('input, select, textarea')) {
        console.warn(LOG + ' Struttura del modulo Brevo non riconosciuta (cane ' + n + '): logica dei cani non attiva.');
        return null;
      }
      dogs.push({
        breed: breed,
        other: other,
        birth: birth,
        groupBlocks: [title, blockOf(breed), blockOf(birth)],
        otherBlock: blockOf(other)
      });
    }
    form.setAttribute('data-mfg-cani', '');

    function selectedCount() {
      var checked = form.querySelector('input[name="NUM_CANI_TOTALE"]:checked');
      return (checked && DOGS_BY_VALUE[checked.value]) || 0;
    }

    // Stessa pulizia degli errori fatta da Brevo.
    function clearErrors(block) {
      each(block.querySelectorAll('.form__entry'), function (entry) {
        entry.classList.remove('entry_errored');
        each(entry.querySelectorAll('.entry__error'), function (label) {
          label.style.display = 'none';
          label.textContent = '';
        });
      });
    }

    // Senza eventi: su un campo data un "change" aprirebbe il calendario di Brevo.
    function clearField(field) {
      field.value = '';
      field.removeAttribute('data-touched');
    }

    function apply() {
      var count = selectedCount();
      dogs.forEach(function (dog, i) {
        var visible = i === 0 || i < count;
        if (i > 0) {
          dog.groupBlocks.forEach(function (block) {
            block.hidden = !visible;
          });
          // Razza e data obbligatorie solo per i cani mostrati, come per il primo cane.
          [dog.breed, dog.birth].forEach(function (field) {
            field.disabled = !visible;
            setAttr(field, 'data-required', visible ? 'true' : null);
            setAttr(labelOf(field), 'data-required', visible ? '*' : null);
            if (!visible) clearField(field);
          });
          setAttr(dog.breed.closest('.sib-select'), 'data-required', visible ? 'true' : null);
          dog.birth.required = visible;
          if (!visible) dog.groupBlocks.forEach(clearErrors);
        }
        var showOther = visible && dog.breed.value === OTHER_BREED_VALUE;
        dog.otherBlock.hidden = !showOther;
        dog.other.disabled = !showOther;
        if (!showOther) {
          clearField(dog.other);
          clearErrors(dog.otherBlock);
        }
      });
    }

    function onChange(event) {
      var name = event.target.name;
      if (name === 'NUM_CANI_TOTALE' || /^RAZZA_CANE(_[2-5])?$/.test(name)) apply();
    }
    // Dopo un invio riuscito Brevo svuota il modulo con form.reset().
    function onReset() {
      setTimeout(apply, 0);
    }

    form.addEventListener('change', onChange);
    form.addEventListener('reset', onReset);
    // Pagina ripristinata dal browser (tasto Indietro).
    window.addEventListener('pageshow', apply);
    apply();

    return {
      apply: apply,
      destroy: function () {
        form.removeEventListener('change', onChange);
        form.removeEventListener('reset', onReset);
        window.removeEventListener('pageshow', apply);
        form.removeAttribute('data-mfg-cani');
      }
    };
  }

  /* ---------------------------------------------------------------------------
   * 2. Popup
   * ------------------------------------------------------------------------- */

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), ' +
    'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var OVERLAY_Z = 9000; // z-index della sovrapposizione (vedi CSS)
  var HASH = '#mfg-questionario';
  // Rilevamento visivo: non legge né modifica il consenso del visitatore.
  var COMMON_OVERLAYS = '#shopify-pc__banner, #onetrust-banner-sdk, #CybotCookiebotDialog, .iubenda-cs-container, [role="dialog"], dialog[open]';

  function isVisible(el) {
    if (!el.getClientRects().length) return false;
    var style = window.getComputedStyle(el);
    return style.visibility !== 'hidden' && style.display !== 'none';
  }

  // Elementi del tema disegnati sopra il popup (es. banner dei cookie): devono restare utilizzabili.
  function rendersAboveOverlay(el) {
    var style = window.getComputedStyle(el);
    if (style.position !== 'fixed' && style.position !== 'sticky') return false;
    var z = parseInt(style.zIndex, 10);
    return !isNaN(z) && z > OVERLAY_Z;
  }

  function openDatePicker() {
    var field = document.activeElement;
    return field && field.getAttribute && field.getAttribute('data-type') === 'date' &&
      document.querySelector('.pika-single:not(.is-hidden)') ? field : null;
  }

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function create(root) {
    var id = root.getAttribute('data-section-id') || 'mfg-q';
    if (instances[id]) return instances[id];

    var overlay = root.querySelector('[data-mfg-q-overlay]');
    var panel = root.querySelector('[data-mfg-q-panel]');
    var body = root.querySelector('[data-mfg-q-body]');
    var launcher = root.querySelector('[data-mfg-q-launcher]');
    var intro = root.querySelector('[data-mfg-q-intro]');
    var thanks = root.querySelector('[data-mfg-q-thanks]');
    var thanksTitle = root.querySelector('[data-mfg-q-thanks-title]');
    var form = root.querySelector('#sib-form');
    var success = root.querySelector('#success-message');
    var error = root.querySelector('#error-message');
    var formContainer = root.querySelector('#sib-form-container');

    if (!overlay || !panel || !body || !form || !success || !error || !formContainer) {
      console.warn(LOG + ' Popup del questionario incompleto: non attivo.');
      return null;
    }
    // Una sola istanza del modulo Brevo nella pagina. Due moduli caricano due volte lo script Brevo:
    // situazione da correggere nel tema (la sezione non viene mostrata sul modello "questionario").
    if (document.querySelectorAll('#sib-form').length > 1) {
      console.warn(LOG + ' Nella pagina ci sono due moduli Brevo (#sib-form): il popup non viene attivato. ' +
        'Togliere il vecchio questionario da questa pagina: due moduli Brevo nella stessa pagina non sono sicuri.');
      root.hidden = true;
      return null;
    }

    var cfg = {
      autoOpen: root.getAttribute('data-auto-open') === 'true',
      delay: Math.max(1, parseInt(root.getAttribute('data-auto-delay'), 10) || 10) * 1000,
      banner: (root.getAttribute('data-cookie-banner') || '').trim()
    };
    var state = { open: false, lastFocus: null, scrollY: 0, inert: [], exempt: [], submitted: false, success: false, timers: [] };
    error.setAttribute('role', 'alert'); // annuncia l'eventuale errore del server
    error.setAttribute('tabindex', '-1');
    var cleanups = [];

    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      cleanups.push(function () { target.removeEventListener(type, fn, opts); });
    }

    // Il popup vive in fondo a <body>: niente problemi con sezioni del tema che usano transform/overflow.
    if (root.parentNode !== document.body) document.body.appendChild(root);

    var dogs = initDogs(form);

    /* --- apertura e chiusura --- */

    function externalOverlays() {
      var found = Array.prototype.slice.call(document.querySelectorAll(COMMON_OVERLAYS));
      if (cfg.banner && cfg.banner !== 'none') {
        try { found = found.concat(Array.prototype.slice.call(document.querySelectorAll(cfg.banner))); }
        catch (e) { console.warn(LOG + ' Selettore facoltativo non valido; uso rilevamento automatico.'); }
      }
      return found.filter(function (el) { return !root.contains(el) && isVisible(el); });
    }

    function bannerVisible() {
      return externalOverlays().length > 0;
    }

    // Il resto della pagina diventa inerte, tranne il calendario di Brevo, il banner dei cookie
    // indicato nelle impostazioni e gli elementi del tema disegnati sopra il popup.
    function makeInert(el) {
      if (el === root || el.inert || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName)) return;
      if (el.classList.contains('pika-single')) return;
      var exempt = rendersAboveOverlay(el) || externalOverlays().some(function (item) {
        return item === el || el.contains(item);
      });
      if (!exempt && cfg.banner && cfg.banner !== 'none') {
        try { exempt = el.matches(cfg.banner) || !!el.querySelector(cfg.banner); } catch (e) { /* selettore non valido */ }
      }
      if (exempt) {
        state.exempt.push(el);
        return;
      }
      el.inert = true;
      state.inert.push(el);
    }

    var bodyObserver = new MutationObserver(function (records) {
      records.forEach(function (record) {
        each(record.addedNodes, function (node) {
          if (node.nodeType === 1 && node.parentNode === document.body) makeInert(node);
        });
      });
    });

    function setInert(active) {
      if (active) {
        each(document.body.children, makeInert);
        bodyObserver.observe(document.body, { childList: true });
      } else {
        bodyObserver.disconnect();
        state.inert.forEach(function (el) { el.inert = false; });
        state.inert = [];
        state.exempt = [];
      }
    }

    function lockScroll(active) {
      var html = document.documentElement;
      if (active) {
        var gap = window.innerWidth - html.clientWidth;
        html.classList.add('mfg-q-lock');
        if (gap > 0) document.body.style.paddingRight = gap + 'px';
      } else {
        html.classList.remove('mfg-q-lock');
        document.body.style.paddingRight = '';
      }
    }

    function fitViewport() {
      var vv = window.visualViewport;
      if (!vv) return;
      root.style.setProperty('--mfg-q-vh', vv.height + 'px');
      root.style.setProperty('--mfg-q-vtop', vv.offsetTop + 'px');
    }

    function focusables() {
      return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), isVisible);
    }

    function isExempt(el) {
      return state.exempt.some(function (item) { return item.contains(el); }) ||
        !!(el.closest && el.closest('.pika-single'));
    }

    function onKeydown(event) {
      if (!state.open) return;
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        var dateField = openDatePicker();
        if (dateField) dateField.blur(); // prima chiude il calendario delle date
        else close();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) {
        event.preventDefault();
        panel.focus();
        return;
      }
      var active = document.activeElement;
      // Dopo un clic o una data scelta dal calendario il focus è sul pannello o sulla pagina:
      // il browser riparte dal punto cliccato; onFocusIn riporta dentro un focus finito fuori.
      if (!active || active === document.body || active === panel) return;
      if (!panel.contains(active)) {
        if (isExempt(active)) return;
        event.preventDefault();
        (event.shiftKey ? items[items.length - 1] : items[0]).focus();
        return;
      }
      var after = items.some(function (el) { return active.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING; });
      var before = items.some(function (el) { return active.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_PRECEDING; });
      if (!event.shiftKey && !after) {
        event.preventDefault();
        items[0].focus();
      } else if (event.shiftKey && !before) {
        event.preventDefault();
        items[items.length - 1].focus();
      }
    }

    function onFocusIn(event) {
      var target = event.target;
      if (!state.open || root.contains(target) || isExempt(target)) return;
      var items = focusables();
      (items[0] || panel).focus({ preventScroll: true });
    }

    // Il calendario di Brevo è posizionato sulla pagina, non dentro il popup:
    // quando il contenuto scorre lo riallineo al campo; se è l'utente a scorrere, lo chiudo.
    function followDatePicker() {
      var field = openDatePicker();
      var picker = field && document.querySelector('.pika-single:not(.is-hidden)');
      if (!picker) return;
      var rect = field.getBoundingClientRect();
      var height = picker.offsetHeight;
      var top = rect.bottom;
      if (top + height > window.innerHeight && rect.top - height > 0) top = rect.top - height;
      picker.style.top = (top + window.pageYOffset) + 'px';
      picker.style.left = (rect.left + window.pageXOffset) + 'px';
    }

    function closeDatePicker() {
      var field = openDatePicker();
      if (field) field.blur();
    }

    function open() {
      if (state.open) return;
      state.open = true;
      state.lastFocus = document.activeElement;
      state.scrollY = window.pageYOffset;
      session(STORE.seen, '1');
      overlay.hidden = false;
      root.classList.add('is-open');
      if (launcher) launcher.setAttribute('aria-expanded', 'true');
      lockScroll(true);
      setInert(true);
      fitViewport();
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', fitViewport);
        window.visualViewport.addEventListener('scroll', fitViewport);
      }
      document.addEventListener('keydown', onKeydown, true);
      document.addEventListener('focusin', onFocusIn);
      body.addEventListener('scroll', followDatePicker, { passive: true });
      body.addEventListener('wheel', closeDatePicker, { passive: true });
      body.addEventListener('touchmove', closeDatePicker, { passive: true });
      panel.focus({ preventScroll: true });
    }

    function close() {
      if (!state.open) return;
      state.open = false;
      overlay.hidden = true;
      root.classList.remove('is-open');
      if (launcher) launcher.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown, true);
      document.removeEventListener('focusin', onFocusIn);
      body.removeEventListener('scroll', followDatePicker);
      body.removeEventListener('wheel', closeDatePicker);
      body.removeEventListener('touchmove', closeDatePicker);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', fitViewport);
        window.visualViewport.removeEventListener('scroll', fitViewport);
      }
      setInert(false);
      lockScroll(false);
      // Brevo, dopo l'invio, fa scorrere la pagina: torno al punto in cui era.
      if (Math.abs(window.pageYOffset - state.scrollY) > 1) window.scrollTo(0, state.scrollY);
      // Il focus torna a ciò che ha aperto il popup (pulsante o link); altrimenti al pulsante.
      var target = state.lastFocus;
      if (!target || target === document.body || root.contains(target) && target !== launcher ||
          !document.contains(target) || typeof target.focus !== 'function' || !isVisible(target)) {
        target = launcher && isVisible(launcher) ? launcher : null;
      }
      if (target) target.focus({ preventScroll: true });
    }

    /* --- esito dell'invio: solo dalla risposta di Brevo --- */

    function showThanks() {
      if (state.success) return;
      state.success = true;
      root.setAttribute('data-state', 'success');
      if (intro) intro.hidden = true;
      if (thanks) thanks.hidden = false;
      if (thanksTitle) panel.setAttribute('aria-labelledby', thanksTitle.id);
      body.scrollTop = 0;
      if (state.open && thanksTitle) thanksTitle.focus({ preventScroll: true });
    }

    function checkResult() {
      // Unico segnale di successo: lo script Brevo aggiunge "sib-form-message-panel--active" a
      // #success-message solo nel ramo "invio accettato" della risposta del server (senza
      // reindirizzamento e senza "pagina di successo"). Serve anche che il modulo sia stato inviato
      // in questa pagina. La sparizione del modulo NON vale come successo: con una "pagina di
      // successo" Brevo mostra la propria pagina nel popup, senza ringraziamento né guida.
      if (state.submitted && success.classList.contains('sib-form-message-panel--active')) {
        showThanks();
        return;
      }
      // Errore del server: porto in vista il messaggio solo nel momento in cui compare.
      var errorShown = error.classList.contains('sib-form-message-panel--active');
      if (errorShown && !state.errorShown && state.open) {
        body.scrollTop = 0;
        error.focus({ preventScroll: true });
      }
      state.errorShown = errorShown;
    }

    var observer = new MutationObserver(checkResult);
    observer.observe(success, { attributes: true, attributeFilter: ['class'] });
    observer.observe(error, { attributes: true, attributeFilter: ['class'] });
    cleanups.push(function () { observer.disconnect(); });

    // Dopo un tentativo di invio con errori: porta in vista il primo campo da correggere.
    on(form, 'submit', function () {
      state.submitted = true; // condizione necessaria, non prova di successo
      setTimeout(function () {
        var entry = form.querySelector('.form__entry.entry_errored');
        if (!entry || !state.open) return;
        var field = entry.querySelector('input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea');
        var top = entry.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop - 24;
        body.scrollTop = Math.max(0, top);
        if (field) field.focus({ preventScroll: true });
      }, 0);
    });

    /* --- comandi --- */

    if (launcher) on(launcher, 'click', open);
    each(root.querySelectorAll('[data-mfg-q-close]'), function (el) {
      on(el, 'click', close);
    });
    // Link o pulsanti del tema che aprono il popup: indirizzo che finisce con #mfg-questionario
    // (anche /#mfg-questionario da un'altra pagina) o attributo data-mfg-q-open.
    on(document, 'click', function (event) {
      var trigger = event.target.closest && event.target.closest('a[href*="' + HASH + '"], [data-mfg-q-open]');
      if (!trigger || root.contains(trigger)) return;
      if (trigger.tagName === 'A') {
        var url = new URL(trigger.href, window.location.href);
        if (url.hash !== HASH || url.pathname !== window.location.pathname) return; // altra pagina: si apre all'arrivo
      }
      event.preventDefault();
      open();
    });
    on(window, 'hashchange', function () {
      if (window.location.hash === HASH) open();
    });

    /* --- apertura automatica (attiva per impostazione iniziale) --- */

    function tryAutoOpen(attempt) {
      if (state.open || state.success || session(STORE.seen)) return;
      var focused = document.activeElement;
      var typing = focused && !root.contains(focused) &&
        (focused.matches('input, textarea, select') || focused.isContentEditable);
      // Aspetta un eventuale dialogo esterno, la scelta cookie, o la fine della digitazione.
      // Senza banner riconosciuto si apre normalmente: nessun selettore richiesto.
      if (document.hidden || bannerVisible() || typing) {
        if (attempt < 300) state.timers.push(setTimeout(function () { tryAutoOpen(attempt + 1); }, 1000));
        return;
      }
      open();
    }

    if (cfg.autoOpen && !designMode() && !session(STORE.seen)) {
      state.timers.push(setTimeout(function () { tryAutoOpen(0); }, cfg.delay));
    }

    var instance = {
      id: id,
      root: root,
      open: open,
      close: close,
      isOpen: function () { return state.open; },
      destroy: function () {
        close();
        bodyObserver.disconnect();
        state.timers.forEach(clearTimeout);
        cleanups.forEach(function (fn) { fn(); });
        if (dogs) dogs.destroy();
        if (root.parentNode) root.parentNode.removeChild(root);
        delete instances[id];
      }
    };
    instances[id] = instance;
    checkResult();
    // Collegamento diretto (es. https://negozio/#mfg-questionario): apertura su richiesta del visitatore.
    if (window.location.hash === HASH && !designMode()) open();
    return instance;
  }

  function initAll(scope) {
    each((scope || document).querySelectorAll('[data-mfg-q]'), create);
  }

  /* ---------------------------------------------------------------------------
   * 3. Editor del tema Shopify
   * ------------------------------------------------------------------------- */

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mfg-q]');
    if (!root) return;
    var instance = create(root);
    var form = root.querySelector('#sib-form');
    // Lo script Brevo si collega al modulo solo al caricamento della pagina. Nell'editor, dopo il
    // ricaricamento della sezione, l'invio resta bloccato finché non si ricarica l'anteprima.
    setTimeout(function () {
      if (!form || form.hasAttribute('novalidate')) return;
      form.setAttribute('novalidate', '');
      form.addEventListener('submit', function (e) { e.preventDefault(); });
      var button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      var note = root.querySelector('[data-mfg-q-editor-reload]');
      if (note) note.hidden = false;
    }, 1000);
    if (instance && designMode()) instance.open();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var instance = instances[event.detail && event.detail.sectionId];
    if (instance) instance.destroy();
  });

  document.addEventListener('shopify:section:select', function (event) {
    var instance = instances[event.detail && event.detail.sectionId];
    if (instance) instance.open();
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var instance = instances[event.detail && event.detail.sectionId];
    if (instance) instance.close();
  });

  window.MFGQuestionario = {
    open: function () {
      var keys = Object.keys(instances);
      if (keys.length) instances[keys[0]].open();
    },
    close: function () {
      Object.keys(instances).forEach(function (k) { instances[k].close(); });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();
